// src/auth.js
const COGNITO_DOMAIN =
  "https://eu-west-12dbmpgkf9.auth.eu-west-1.amazoncognito.com";
const CLIENT_ID = "rqmpdk113ajaoplnq0ve5s28r";

const REDIRECT_URI = "https://vrmo-wbr.pulse-cia.amazon.dev/"; 
// const REDIRECT_URI = "http://localhost:3000/";


const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

export const Auth = {
  login: () => {
    const authUrl =
      `${COGNITO_DOMAIN}/login?` +
      `client_id=${CLIENT_ID}&` +
      `response_type=code&` +
      `scope=email+openid+phone&` +
      `redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;

    window.location.href = authUrl;
  },

  isAuthenticated: () => {
    const idToken = localStorage.getItem("id_token");
    if (!idToken) return false;

    const decoded = decodeToken(idToken);
    if (!decoded || !decoded.exp) return false;

    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp < now) {
      localStorage.removeItem("id_token");
      localStorage.removeItem("access_token");
      return false;
    }

    return true;
  },

  getUser: () => {
    const idToken = localStorage.getItem("id_token");
    if (!idToken) return null;
    return decodeToken(idToken);
  },

  getToken: () => localStorage.getItem("id_token"),

  logout: () => {
    localStorage.removeItem("id_token");
    localStorage.removeItem("access_token");
    window.location.href =
      `${COGNITO_DOMAIN}/logout?` +
      `client_id=${CLIENT_ID}&` +
      `logout_uri=${encodeURIComponent(REDIRECT_URI)}`;
  },

  // ✅ More robust token exchange with better error handling
  async exchangeCode(code) {
    console.log("Exchanging code for tokens...");

    const response = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        grant_type: "authorization_code",
        client_id: CLIENT_ID,
        code: code,
        redirect_uri: REDIRECT_URI,
      }),
    });

    if (!response.ok) {
      const errorBody = await response.text();
      console.error("Token exchange failed:", response.status, errorBody);

      // ✅ If "invalid_grant" it means code was already used (StrictMode)
      if (errorBody.includes("invalid_grant")) {
        console.warn("Code already used — checking if tokens exist...");
        if (Auth.isAuthenticated()) {
          return { alreadyExchanged: true };
        }
      }

      throw new Error(`Token exchange failed: ${response.status}`);
    }

    const data = await response.json();
    console.log("Token exchange successful");

    localStorage.setItem("id_token", data.id_token);
    if (data.access_token) {
      localStorage.setItem("access_token", data.access_token);
    }
    return data;
  },

  getCodeFromUrl: () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("code");
  },

  // ✅ Clean both search params and preserve hash
  cleanUrl: () => {
    const cleanedUrl =
      window.location.origin +
      window.location.pathname +
      window.location.hash;
    window.history.replaceState({}, document.title, cleanedUrl);
  },
};